import { AxiosError } from 'axios';

export interface ErrorResponse {
  error_msg: string;
}

export class QueryError extends Error implements ErrorResponse {
  constructor(error: AxiosError<{ errorMsg: string }>) {
    super(error.response?.data.errorMsg || error.message);
  }

  get error_msg(): string {
    return this.message;
  }
}
